import api from "@/lib/axios";

// post request that takeids in an array and download the cvs of the candidates
export const downloadcvsService = {

  downloadcvs: async (ids, vacancyId = null, filters = null) => {
    try {
      let payload = {};
      
      // If no application IDs provided, only send vacancy_id
      if (!ids || ids.length === 0) {
        if (vacancyId) {
          payload = { vacancy_id: vacancyId };
        } else {
          throw new Error("Either application IDs or vacancy ID must be provided");
        }
      } else {
        // If application IDs provided, send both application_ids and vacancy_id
        payload = { application_ids: ids };
        if (vacancyId) {
          payload.vacancy_id = vacancyId;
        }
      }
      
      // Add filters to payload using spread operator if provided
      if (filters && Object.keys(filters).length > 0) {
        payload = { ...payload, ...filters };
      }
      
      const response = await api.post("/download-cvs", payload);
      return response.data;
    } catch (error) {
      throw new Error("Failed to download cvs: " + error.message);
    }
  },
};

